import { render, staticRenderFns } from "./rc-alert-local-storage.vue?vue&type=template&id=2ff4c784&scoped=true&"
import script from "./rc-alert-local-storage.vue?vue&type=script&lang=js&"
export * from "./rc-alert-local-storage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff4c784",
  null
  
)

export default component.exports